// Mock data for Bhargav Pancholi's Portfolio

export const portfolioData = {
  personal: {
    name: "Bhargav Pancholi",
    role: "Revenue Operations & Sales Manager",
    tagline: "Scaling B2B growth through strategic RevOps & data-driven sales excellence",
    bio: "RevOps leader driving $2M+ ARR growth through CRM optimization, process automation, and strategic sales execution across tech & SaaS markets.",
    email: "bhargavp.work@gmail.com",
    phone: "+1 (519) 697-6446",
    linkedin: "https://linkedin.com/in/bhargav-pancholi",
    calendly: "https://calendly.com/bhargavp-work/30min",
    resumePdf: "https://customer-assets.emergentagent.com/job_b3af6eb3-5923-469c-8b61-5f25a36ac1de/artifacts/jtd7ouhc_Bhargav%20Pancholi_2025-10-30_07-24-18.docx-3.pdf",
    headshot: "https://customer-assets.emergentagent.com/job_b3af6eb3-5923-469c-8b61-5f25a36ac1de/artifacts/s09olpjn_IMG_8121%202.jpg"
  },

  coreStrengths: [
    "RevOps Strategy & Execution",
    "CRM Optimization (Salesforce, HubSpot)",
    "B2B Sales Growth & Pipeline Management",
    "Process Automation & ERP Implementation",
    "Data-Driven Decision Making"
  ],

  highlights: [
    {
      id: 1,
      logo: "TrendingUp",
      metric: "$2M ARR",
      description: "Scaled B2B customer base from 0 to 100+ across Ontario in 18 months",
      color: "teal"
    },
    {
      id: 2,
      logo: "Zap",
      metric: "30% Faster",
      description: "Reduced cycle time through ERP+CRM stack implementation & automation",
      color: "violet"
    },
    {
      id: 3,
      logo: "Target",
      metric: "105% Quota",
      description: "Exceeded upsell & renewal targets through consultative SaaS solutions",
      color: "purple"
    },
    {
      id: 4,
      logo: "DollarSign",
      metric: "25-70% Savings",
      description: "Negotiated vendor contracts, improving SLA compliance & margins",
      color: "blue"
    },
    {
      id: 5,
      logo: "LineChart",
      metric: "38% Growth",
      description: "Expanded US & Canadian distribution through strategic partnerships",
      color: "cyan"
    },
    {
      id: 6,
      logo: "Users",
      metric: "95%+ SLA",
      description: "Resolved client escalations, driving retention across 40+ implementations",
      color: "indigo"
    }
  ],

  // Experience section removed - converted to Selected Work case studies

  projects: [
    {
      id: 1,
      title: "RevOps Transformation at Ingrano",
      company: "SEPL Global Limited (Ingrano)",
      category: "Revenue Operations",
      situation: "Zero RevOps infrastructure with manual processes limiting scalability and growth",
      task: "Build comprehensive RevOps foundation to enable $2M ARR target within 18 months",
      action: "Implemented integrated ERP+CRM stack with automated workflows & reporting dashboards",
      result: "30% cycle time reduction, $2M ARR, 100+ customer base in 18 months",
      metric: "$2M ARR Growth",
      tags: ["ERP Implementation", "CRM Integration", "Process Automation"],
      color: "teal"
    },
    {
      id: 2,
      title: "B2B Customer Base Scaling",
      company: "SEPL Global Limited (Ingrano)",
      category: "Business Development",
      situation: "Starting from zero customer base in Ontario market with no established presence",
      task: "Scale B2B customer acquisition to 100+ accounts across Ontario within 18 months",
      action: "Developed targeted outreach strategy, built sales pipeline, and executed consultative sales approach",
      result: "Scaled B2B customer base from 0 to 100+ across Ontario, contributing to $2M ARR",
      metric: "0 to 100+ Customers",
      tags: ["Business Development", "Sales Strategy", "Customer Acquisition"],
      color: "cyan"
    },
    {
      id: 3,
      title: "Vendor Contract Cost Optimization",
      company: "SEPL Global Limited (Ingrano)",
      category: "Operations Excellence",
      situation: "High vendor & logistics costs eroding margins and limiting GTM investment capacity",
      task: "Reduce operational costs by 25%+ while maintaining or improving service level agreements",
      action: "Audited contracts, negotiated terms with key vendors, optimized service levels & logistics",
      result: "25-70% cost reduction, improved SLA compliance, freed budget for growth initiatives",
      metric: "25-70% Cost Savings",
      tags: ["Contract Negotiation", "Vendor Management", "Cost Optimization"],
      color: "indigo"
    },
    {
      id: 4,
      title: "Multi-Market Distribution Expansion",
      company: "SEPL Global Limited (Ingrano)",
      category: "Go-to-Market",
      situation: "Single-market presence limiting growth potential and revenue ceiling",
      task: "Expand distribution to US & Canadian markets to diversify revenue streams and boost sales",
      action: "Identified & onboarded strategic distribution partners in NJ, CA, and Vancouver markets",
      result: "38% sales increase, expanded market reach, diversified revenue streams across North America",
      metric: "38% Sales Boost",
      tags: ["Partnership Development", "Market Expansion", "GTM Strategy"],
      color: "purple"
    },
    {
      id: 5,
      title: "Client Implementation Scaling",
      company: "Fleet Complete",
      category: "Customer Success",
      situation: "Growing client base requiring efficient escalation resolution & retention management",
      task: "Manage 40+ annual implementations while maintaining 95%+ SLA compliance and high retention",
      action: "Managed 40+ annual implementations with structured SLA-based escalation framework",
      result: "95%+ SLA compliance, high retention rates, exceeded renewal quotas by 105%",
      metric: "95%+ SLA Achievement",
      tags: ["Implementation", "Customer Success", "SaaS"],
      color: "blue"
    },
    {
      id: 6,
      title: "Sales Tech Stack Optimization",
      company: "Fleet Complete",
      category: "Sales Enablement",
      situation: "Underutilized Salesforce, SalesLoft, ZoomInfo causing inefficient workflows and lost productivity",
      task: "Optimize sales tech stack to increase team productivity by 25% and improve quota attainment",
      action: "Partnered with RevOps to redesign processes, optimize configurations & train sales teams",
      result: "25% productivity increase, 105% quota attainment across sales organization",
      metric: "25% Productivity Gain",
      tags: ["Salesforce", "SalesLoft", "Sales Operations"],
      color: "violet"
    },
    {
      id: 7,
      title: "Consultative Upsell & Renewal Strategy",
      company: "Fleet Complete",
      category: "Account Management",
      situation: "Need to exceed upsell and renewal quotas while maintaining exceptional customer satisfaction",
      task: "Achieve 100%+ of upsell and renewal quotas through consultative selling approach",
      action: "Led product demos translating client pain points into expansion opportunities with tailored solutions",
      result: "Exceeded upsell and renewal quotas by 105% through consultative SaaS solutions",
      metric: "105% Quota Achievement",
      tags: ["Account Management", "Consultative Selling", "Customer Expansion"],
      color: "teal"
    },
    {
      id: 8,
      title: "Product Discovery & Demo Excellence",
      company: "Fleet Complete",
      category: "Sales Engineering",
      situation: "Clients struggling to articulate pain points and see value in SaaS platform capabilities",
      task: "Conduct discovery sessions and demos that uncover needs and drive expansion opportunities",
      action: "Led structured product demos and discovery sessions translating client requirements into solutions",
      result: "Generated consistent expansion pipeline, supported 105% quota achievement, improved client satisfaction",
      metric: "Expansion Pipeline Growth",
      tags: ["Product Demos", "Discovery", "Solution Consulting"],
      color: "cyan"
    },
    {
      id: 9,
      title: "Outbound Prospecting Engine",
      company: "KochaSoft Inc.",
      category: "Business Development",
      situation: "No structured outbound process causing limited pipeline generation and unclear lead sources",
      task: "Generate 40+ SQLs through outbound prospecting to achieve $150K+ closed revenue target",
      action: "Developed multi-channel outbound strategy with targeted messaging and consistent follow-up cadence",
      result: "Generated 40+ SQLs through outbound prospecting, leading to $150K+ closed revenue",
      metric: "$150K+ Pipeline",
      tags: ["Outbound Sales", "Prospecting", "Lead Generation"],
      color: "purple"
    },
    {
      id: 10,
      title: "HubSpot CRM Foundation Build",
      company: "KochaSoft Inc.",
      category: "CRM Development",
      situation: "No structured CRM processes causing lost leads and unclear pipeline visibility",
      task: "Build end-to-end CRM system to improve lead tracking, pipeline management and sales-marketing alignment",
      action: "Built comprehensive HubSpot workflows for lead tracking, pipeline management & sales handoffs",
      result: "Improved lead tracking and pipeline visibility, supported $150K+ closed revenue, enhanced team efficiency",
      metric: "CRM Foundation Established",
      tags: ["HubSpot", "Process Design", "Pipeline Management"],
      color: "indigo"
    },
    {
      id: 11,
      title: "Strategic LMS Partnership Development",
      company: "KochaSoft Inc.",
      category: "Partnership Strategy",
      situation: "SaaS platform lacking content library needed to compete with established LMS providers",
      task: "Forge strategic partnership to deliver curated LMS content alongside SaaS platform",
      action: "Identified, pitched, and negotiated OpenSesame partnership to deliver integrated content solution",
      result: "Successfully launched integrated offering, differentiated product, aligned GTM strategy with client needs",
      metric: "Strategic Partnership Launched",
      tags: ["Partnership Development", "Business Development", "GTM Strategy"],
      color: "blue"
    },
    {
      id: 12,
      title: "Product-Market Fit Acceleration",
      company: "KochaSoft Inc.",
      category: "Product Strategy",
      situation: "Product in prototype stage requiring client feedback alignment for market readiness",
      task: "Bridge gap between client needs and product capabilities to achieve market-ready solution",
      action: "Partnered with development team to align client feedback with product improvements and features",
      result: "Moved product from prototype to market-ready solution, improved client satisfaction, enabled revenue growth",
      metric: "Market-Ready Product",
      tags: ["Product Strategy", "Client Feedback", "Cross-Functional Collaboration"],
      color: "violet"
    }
  ],

  toolsAndSoftware: [
    { name: "Salesforce", logo: "https://cdn.worldvectorlogo.com/logos/salesforce-2.svg" },
    { name: "HubSpot", logo: "https://logo.clearbit.com/hubspot.com" },
    { name: "SalesLoft", logo: "https://logo.clearbit.com/salesloft.com" },
    { name: "Clari", logo: "https://logo.clearbit.com/clari.com" },
    { name: "ZoomInfo", logo: "https://logo.clearbit.com/zoominfo.com" },
    { name: "LinkedIn", logo: "https://cdn.worldvectorlogo.com/logos/linkedin-icon-2.svg" },
    { name: "Microsoft Excel", logo: "https://cdn.worldvectorlogo.com/logos/excel-4.svg" },
    { name: "Google Sheets", logo: "https://logo.clearbit.com/google.com" },
    { name: "Slack", logo: "https://cdn.worldvectorlogo.com/logos/slack-new-logo.svg" },
    { name: "Microsoft Teams", logo: "https://cdn.worldvectorlogo.com/logos/microsoft-teams-1.svg" },
    { name: "ERP Systems", logo: "https://cdn.worldvectorlogo.com/logos/odoo.svg" },
    { name: "VoIP Systems", logo: "https://cdn.worldvectorlogo.com/logos/twilio-2.svg" },
    { name: "KPI Dashboards", logo: "https://cdn.worldvectorlogo.com/logos/tableau-software.svg" },
    { name: "Reporting Tools", logo: "https://cdn.worldvectorlogo.com/logos/power-bi.svg" }
  ],

  skillsAndExpertise: {
    technical: [
      "Revenue Forecasting",
      "Data Analysis & Visualization",
      "Pipeline Management",
      "CRM Administration",
      "Process Automation",
      "KPI Development",
      "Quota Setting",
      "Sales Process Optimization",
      "Business Intelligence (BI)",
      "Revenue Cycle Management",
      "Business Development",
      "Churn Management",
      "Customer Success",
      "AI/Automation Technologies",
      "Metric Dashboard Creation"
    ],
    soft: [
      "Cross-Functional Collaboration",
      "Strategic Planning",
      "Stakeholder Management",
      "Communication",
      "Analytical Mindset",
      "Project Management",
      "Problem Solving",
      "Change Management",
      "Leadership",
      "Adaptability",
      "Customer Relationship Management",
      "Decision-Making",
      "Time Management",
      "Solution Consulting",
      "Negotiation Skills"
    ]
  },

  testimonials: [
    {
      id: 1,
      quote: "Bhargav transformed our RevOps infrastructure, delivering measurable results within months. His strategic approach to CRM optimization was game-changing.",
      author: "Managing Director",
      company: "SEPL Global Limited",
      role: "Executive Leadership"
    },
    {
      id: 2,
      quote: "A consultative partner who truly understands client needs. Bhargav consistently exceeded quotas while maintaining exceptional customer satisfaction.",
      author: "Manager, Business Development",
      company: "Fleet Complete",
      role: "Sales Leadership"
    },
    {
      id: 3,
      quote: "Bhargav is meticulous and works exceptionally hard. He's innovative in outbound, quickly grasps complex technologies, and leverages connections to create pipeline. Highly recommended for any sales role.",
      author: "Account Director",
      company: "KochaSoft Inc.",
      role: "Sales Leadership"
    }
  ],

  education: [
    {
      institution: "Fanshawe College, ON",
      degree: "Post Graduate Diploma in Business Management",
      year: ""
    },
    {
      institution: "Sardar Patel University, Gujarat, India",
      degree: "MBA, Marketing",
      year: ""
    }
  ],

  certifications: [
    {
      name: "Tech Sales Bootcamp",
      issuer: "Uvaro, ON",
      description: "Tech sales, pipeline management, prospecting, CRM management, closing techniques"
    }
  ]
};
